import { render, staticRenderFns } from "./AiGradingQuote.vue?vue&type=template&id=04bda793&scoped=true&"
import script from "./AiGradingQuote.vue?vue&type=script&lang=ts&"
export * from "./AiGradingQuote.vue?vue&type=script&lang=ts&"
import style0 from "./AiGradingQuote.vue?vue&type=style&index=0&id=04bda793&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bda793",
  null
  
)

export default component.exports